import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@localize/i18n.module';
import { HighlightModule } from 'ngx-highlightjs';

import { AngularMaterialModule } from '../../shared/angular-material.module';
import { DirectivesModule } from '../directives';
import { ConfirmDialogComponent, PlainDialogComponent } from '../services/feedback/dialogs';
import { SpinnerCoverComponent } from '../services/progress';
import {
	AlertBadgeComponent,
	AlertBannerComponent,
	BuildVersionComponent,
	DisplayTableComponent,
	FormArrayTableComponent,
	FormEditorComponent,
	FormFieldEditorComponent,
	LinkTableComponent,
	LoaderWrapperComponent,
	SearchSelectComponent,
	SideMenuComponent
} from './components';

const modules = [
	DirectivesModule,
	HighlightModule,
	AngularMaterialModule,
	ReactiveFormsModule,
	I18nModule,
	CommonModule,
	FormsModule,
	RouterModule
];

const components = [
	AlertBadgeComponent,
	AlertBannerComponent,
	SearchSelectComponent,
	BuildVersionComponent,
	DisplayTableComponent,
	FormArrayTableComponent,
	FormEditorComponent,
	FormFieldEditorComponent,
	LinkTableComponent,
	LoaderWrapperComponent,
	SideMenuComponent,
	PlainDialogComponent,
	ConfirmDialogComponent,
	SpinnerCoverComponent
];

@NgModule({
	imports: [...modules],
	exports: [...modules, ...components],
	declarations: [...components],
	providers: []
})
export class SharedModule {}
